"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var selectors = _interopRequireWildcard(require("../../store/personalIntegration/personalIntegration.selector"));

var actions = _interopRequireWildcard(require("../../store/personalIntegration/personalIntegration.actions"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    title: {
      marginBottom: spacing(1)
    }
  };
});

var IntegrationServices = function IntegrationServices(_ref2) {
  var strategy = _ref2.strategy;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(selectors.integrationsIsLoading);
  var isDkimEnabled = (0, _reactRedux.useSelector)(selectors.isDkimEnabled);
  var onServiceClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    var service = event.currentTarget.dataset.service;
    dispatch(actions.openIntegrationService({
      service,
      script: strategy,
      scopes: {
        email: !isDkimEnabled,
        calendar: true
      }
    }));
  }, [dispatch, isDkimEnabled, strategy]);
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: 2,
    m: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 3 / 4,
    pb: 1,
    pt: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: 2,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('H4-Dark-Bold', classes.title)
  }, "Google integration")), /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: 2,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Regular-Left-Static')
  }, "Integrating your Google account allows Alyce to automatically add meetings on your Google calendar any time a prospect accepts your terms. Less work for you and more meetings. Win win!"))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 4,
    pb: 1,
    pt: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: 2,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.EmailIntegrationButton, {
    signIn: true,
    onClick: onServiceClick,
    "data-service": "google",
    variant: "google"
  })))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: 2,
    m: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 3 / 4,
    pb: 1,
    pt: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: 2,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('H4-Dark-Bold', classes.title)
  }, "Outlook integration")), /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: 2,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Regular-Left-Static')
  }, "Integrating your Outlook account allows Alyce to automatically add meetings on your Outlook calendar any time a prospect accepts your terms. Less work for you and more meetings. Win win!"))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 4,
    pb: 1,
    pt: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_ui.LoadingWrapper, {
    isLoading: isLoading,
    mt: 2,
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.EmailIntegrationButton, {
    signIn: true,
    onClick: onServiceClick,
    "data-service": "outlook",
    variant: "outlook"
  })))));
};

IntegrationServices.propTypes = {
  strategy: _propTypes.default.string
};
IntegrationServices.defaultProps = {
  strategy: ''
};
var _default = IntegrationServices;
exports.default = _default;